import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { H as HOME } from '../paths-ZKN3m62_.js';

const useGetPageClass = () => {
    const { pathname } = useRouter();
    const containsList = [
        { term: 'checkout', class: 'checkout' },
        { term: '/p/', class: 'product' },
        { term: '/account/', class: 'account' },
    ];
    const equalsList = [{ term: HOME, class: 'home' }];
    const className = useMemo(() => {
        const contains = containsList.filter(item => pathname.includes(item.term));
        const equals = equalsList.filter(item => item.term === pathname);
        return [...contains, ...equals].map(item => item.class).join(' ');
    }, [pathname]);
    return className;
};

export { useGetPageClass as default };
//# sourceMappingURL=useGetPageClass.js.map
